import { render, staticRenderFns } from "./DemandCollectDetail.vue?vue&type=template&id=40b174a2&scoped=true&"
import script from "./DemandCollectDetail.vue?vue&type=script&lang=js&"
export * from "./DemandCollectDetail.vue?vue&type=script&lang=js&"
import style0 from "./DemandCollectDetail.vue?vue&type=style&index=0&id=40b174a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b174a2",
  null
  
)

export default component.exports